// components/Checkbox.jsx

const Checkbox = ({ checked, onChange, className = "" }) => {
    return (
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className={`h-4 w-4 accent-blue-600 cursor-pointer ${className}`}
      />
    );
  };
  
  export default Checkbox;
  